import { FC, memo } from 'react';
import { Table } from 'shared/ui/Table';
import { FeedbackListItem } from 'entities/feedback';
import { FEEDBACK_TABLE_COLUMNS } from '../../constants/feedbackConstants';

interface FeedbackTableProps {
  feedbacks: FeedbackListItem[];
  onDelete: (id: number) => void;
  onView: (feedback: FeedbackListItem) => void;
}

export const FeedbackTable: FC<FeedbackTableProps> = memo(({
  feedbacks,
  onDelete,
  onView,
}) => {
  const actions = [
    {
      key: 'view',
      label: 'Просмотр',
      onClick: (record: FeedbackListItem) => onView(record),
    },
    {
      key: 'delete',
      label: 'Удалить',
      onClick: (record: FeedbackListItem) => onDelete(record.id),
      danger: true,
    },
  ];

  return (
    <Table
      columns={FEEDBACK_TABLE_COLUMNS}
      dataSource={feedbacks}
      rowKey="id"
      hasPagination
      actions={actions}
      enableFullTableSearch
      enableClearFilters
      onRowDoubleClick={(record: FeedbackListItem) => onView(record)}
    />
  );
});

FeedbackTable.displayName = 'FeedbackTable';
